<div class="sas-notifications">
  <sas-button type="icon"
              icon="bi-bell"
              text="NOTIFICATIONS"
              [iconOnly]="true"
              [showDot]="hasNotifications()"
              (sasOnClick)="togglePanel()">
  </sas-button>

  @if (panelOpen()) {
    @if (loaded()) {
  <ul class="sas-notification-list list-unstyled"
      [style.top.px]="listTop()"
      [attr.aria-label]="'NOTIFICATIONS' | translate">
      @if (planningSubmissionsReceived() > 0) {
      <li>
          <sas-related-item [kind]="'PLANNING_SUBMISSIONS_RECEIVED' | translate: { Default: 'Planning submissions received' }"
                            [ref]="planningSubmissionsReceived() + ' ' + ('PLANNING_SUBMISSIONS_PENDING_REVIEW' | translate: { Default: 'pending review' })"
                            [refClickable]="true"
                            (sasAction)="openPlanningSubmissions()">
          </sas-related-item>
      </li>
      }

      @if (pendingSignatureReceived() > 0) {
      <li>
          <sas-related-item [kind]="'SIGNATURE_RECEIVED' | translate: { Default: 'Pending signature requests' }"
                            [ref]="pendingSignatureReceived() + ' ' + ('SIGNATURE_PENDING_REVIEW' | translate: { Default: 'pending review' })"
                            [refClickable]="true"
                            (sasAction)="openPendingSignatures()">
          </sas-related-item>
      </li>
      }

      @if (pendingCitizenComments() > 0) {
      <li>
          <sas-related-item [kind]="'PENDING_CITIZEN_COMMENTS' | translate: { Default: 'Pending citizen comments' }"
                            [ref]="pendingCitizenComments() + ' ' + ('CITIZEN_COMMENTS_PENDING_REVIEW' | translate: { Default: 'pending review' })"
                            [refClickable]="true"
                            (sasAction)="openPendingCitizenComments()">
          </sas-related-item>
      </li>
      }

      @if (pendingConsulteeComments() > 0) {
      <li>
          <sas-related-item [kind]="'PENDING_CONSULTEE_COMMENTS' | translate: { Default: 'Pending consultee comments' }"
                            [ref]="pendingConsulteeComments() + ' ' + ('CONSULTEE_COMMENTS_PENDING_REVIEW' | translate: { Default: 'pending review' })"
                            [refClickable]="true"
                            (sasAction)="openPendingConsulteeComments()">
          </sas-related-item>
      </li>
      }

      @for (item of notifications(); track item.id) {
      <li>
          <sas-related-item [kind]="item.type | translate: { Default: typeLabel(item.type) }"
                            [ref]="getSubtitle(item)"
                            [refClickable]="true"
                            [meta]="formatDate(item.createdDate)"
                            [dismissible]="true"
                            dismissLabel="DISMISS"
                            (sasAction)="openNotification(item)"
                            (sasDismiss)="dismiss(item, $event)">
          </sas-related-item>
      </li>
      }

      @if (!hasPending()) {
      <li>
          <sas-related-item [kind]="'NOTIFICATIONS' | translate: { Default: 'Notifications' }"
                            [ref]="'NO_NOTIFICATIONS' | translate: { Default: 'No notifications' }"
                            [empty]="true"
                            [dismissible]="true"
                            dismissLabel="CLOSE"
                            (sasDismiss)="closePanel()">
          </sas-related-item>
      </li>
      }
  </ul>
    }
  }
</div>
